// extracted by mini-css-extract-plugin
module.exports = {"content":"alert-with-close-button_content__DAiD5","bottomButton":"alert-with-close-button_bottomButton__hrh35"};